export default function portalTitle(partner) {
  if (partner) return 'Partneri felület';

  return 'Adminisztrátori felület';
}
